"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var lodash_1 = require("lodash");
var url_helpers_1 = require("../shared/url_helpers");
var date_utils_1 = require("../../lib/date_utils");
var LP_MERCHANDISING_TYPE = 'lp';
var DIGITAL_MERCHANDISING_TYPE = 'digital';
var FeedbackOrderInfo = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackOrderInfo, _super);
    function FeedbackOrderInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FeedbackOrderInfo.prototype, "order", {
        get: function () {
            return this.props.order;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackOrderInfo.prototype, "listing", {
        get: function () {
            return this.props.order.listing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackOrderInfo.prototype, "legacyOrderId", {
        get: function () {
            return this.order.legacyOrderId;
        },
        enumerable: true,
        configurable: true
    });
    FeedbackOrderInfo.prototype.boughtOrSoldText = function () {
        if (this.props.isBuyer) {
            return I18n.t('discovery.feedbackOrderInfo.youBought');
        }
        return I18n.t('discovery.feedbackOrderInfo.youSold');
    };
    FeedbackOrderInfo.prototype.orderPath = function () {
        if (this.props.isBuyer) {
            return url_helpers_1.default.purchasePath({ orderId: this.legacyOrderId });
        }
        return url_helpers_1.default.orderPath({ orderId: this.legacyOrderId });
    };
    FeedbackOrderInfo.prototype.orderNumberText = function () {
        return (React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.feedbackOrderInfo.orderNumberHtml', {
                orderNumber: this.legacyOrderId,
                linkOpen: "<a href=\"" + this.orderPath() + "\">",
                linkClose: '</a>',
            }) }));
    };
    FeedbackOrderInfo.prototype.hasShippedAt = function () {
        // order will always haved proto shippedAt, which defaults to 0
        // which is equivalent to an order having nil shipped_at
        return !this.order.shippedAt || this.order.shippedAt.seconds > 0;
    };
    FeedbackOrderInfo.prototype.statusText = function () {
        var status = this.order.status.toString();
        var date = this.hasShippedAt() ? date_utils_1.formatInternationalizedSeconds(this.order.shippedAt.seconds) : '';
        if (status === 'UNPAID' || status === 'PAYMENT_PENDING' || status === 'PARTIALLY_PAID') {
            return I18n.t('discovery.feedbackOrderInfo.status.waitingForPayment');
        }
        if (status === 'PRESUMED_RECEIVED') {
            return I18n.t('discovery.feedbackOrderInfo.status.presumedReceived');
        }
        if (this.hasShippedAt() && status === 'SHIPPED') {
            return I18n.t('discovery.feedbackOrderInfo.status.shipped', {
                date: date,
            });
        }
        if (this.hasShippedAt() || status === 'PICKED_UP') {
            return I18n.t('discovery.feedbackOrderInfo.status.pickedUp', {
                date: date,
            });
        }
        if (this.listing.merchandisingType !== DIGITAL_MERCHANDISING_TYPE) {
            return I18n.t('discovery.feedbackOrderInfo.status.awaitingShipment');
        }
    };
    FeedbackOrderInfo.prototype.listingUrl = function () {
        if (this.listing.merchandisingType === LP_MERCHANDISING_TYPE) {
            return url_helpers_1.default.lpListingDefaultUrl(this.listing.id);
        }
        return url_helpers_1.default.listingPagePath(this.listing.id, this.listing.slug);
    };
    FeedbackOrderInfo.prototype.render = function () {
        var imageSource = lodash_1.get(this.order, 'listing.images[0].source');
        return (React.createElement("div", null,
            React.createElement("p", { className: "mb-0 strong" }, this.boughtOrSoldText()),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-4 mobile-mb-1 bd-1 bd--offwhite" },
                    React.createElement("a", { href: this.listingUrl() },
                        React.createElement("img", { className: "img-wide img-hoverable", src: imageSource, alt: this.listing.title }))),
                React.createElement("div", { className: "g-col-8" },
                    React.createElement("p", { className: "mb-0 extratight-line-height strong" },
                        React.createElement("a", { href: this.listingUrl() }, this.listing.title)),
                    React.createElement("p", { className: "mb-0 strong" }, this.order.amountTotal.display),
                    React.createElement("p", { className: "mb-0" }, this.orderNumberText()),
                    React.createElement("p", { className: "mb-0" }, I18n.t('discovery.feedbackOrderInfo.status.orderedAt', {
                        date: date_utils_1.formatInternationalizedSeconds(this.order.createdAt.seconds),
                    })),
                    React.createElement("p", { className: "mb-0" }, this.statusText())))));
    };
    return FeedbackOrderInfo;
}(React.Component));
exports.default = FeedbackOrderInfo;
//# sourceMappingURL=feedback_order_info.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/feedbacks/feedback_order_info.js
// module id = SaE6
// module chunks = 20 21